import type { FaireReviewEntity } from "../../entity_types/review";

// Real product review, pulled from Sweet Wink's live Faire product page for
// the Coquette Pumpkin Knit Sweater (faire.com/product/p_8qgn78wy22), via the
// public, unauthenticated `GET /api/product-reviews/product/{product_token}`
// endpoint (the same one the PDP itself calls) — verbatim reviewer
// name/location/text/date, nothing paraphrased or invented.
export const review_sw7: FaireReviewEntity = {
  token: "review_sw7",
  type: "review",
  brandName: "Sweet Wink",
  brandToken: "b_gro99lye",
  productToken: "p_8qgn78wy22",
  productImageUrl:
    "https://cdn.faire.com/fastly/c41f2ada040a23c932274a37440d252c4ebbc35a0085425e17e59886b866bd06.jpeg",
  reviewerName: "Heather B.",
  reviewerLocation: "Collinsville, AL, United States",
  stars: 5,
  reviewText: "I have no words. This sweater is modern, classy and trendy!",
  reviewDate: "Aug 14, 2025",
  reviewType: "product",
  meta: {
    source: "api",
    importedAt: "2026-08-12T07:15:00.000Z",
    importedBy: "entity-db-cli",
  },
};
